/* eslint-disable react/no-array-index-key */
import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from 'react';
import { FilterContext } from '~/context/filter';
import { InputTagSt } from '../../styles';
import { Tags } from '../../MyComponents/Tags';
import { useFiltro } from '../../FiltroContext';
import {
  FilterContainer,
  FilterHeader,
  FilterTitle,
  FilterTitleRow,
  FilterRow,
  DropdownContainer,
  DropdownButton,
  DropdownList,
  DropdownItem,
  FieldContainer,
  FullWidthButton,
} from './styles';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { EnterLabel } from '../../MyComponents/Tags/styles';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';

const options = [
  {
    description: 'Igual à',
    cod_condicao: 0,
  },
  {
    description: 'Contém',
    cod_condicao: 4,
  },
  {
    description: 'Não Contém',
    cod_condicao: 5,
  },
  {
    description: 'Preenchido',
    cod_condicao: 7,
  },
  {
    description: 'Não Preenchido',
    cod_condicao: 8,
  },
];

const optionsExpression = [
  {
    description: 'Igual à',
    cod_condicao: 0,
  },
  {
    description: 'Diferente de',
    cod_condicao: 3,
  },
  {
    description: 'Preenchido',
    cod_condicao: 7,
  },
  {
    description: 'Não Preenchido',
    cod_condicao: 8,
  },
];

const TypeString: React.FC = () => {
  // Condições
  const preenchido = 7;
  const naoPreenchido = 8;

  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const { isFilterBlock, handleSetNewValue, filter, removeFilter } =
    useFiltro();
  const { RemoveFilterEmptyByIndex } = useContext(FilterContext);

  const [value, setValue] = useState<string>('');
  const [tags, setTags] = useState<string[]>(
    Array.isArray(filter.des_valor) ? filter.des_valor : [],
  );
  const [condition, setCondition] = useState(filter.condicao || 0);

  const [isExpression, setExpression] = useState<boolean>(false);
  const [Mask, setMask] = useState<string>('');

  useEffect(() => {
    if (filter.expressao_validacao) {
      setExpression(true);
      setMask(filter.expressao_validacao);
    }
  }, [filter.expressao_validacao]);

  // Fechar dropdown quando clicar fora
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  const handleChangeCondition = (newCondition: number) => {
    setCondition(newCondition);
    setDropdownOpen(false);
  };

  const getConditionText = (condCode: number) => {
    const availableOptions = isExpression ? optionsExpression : options;
    const option = availableOptions.find(
      (opt) => opt.cod_condicao === condCode,
    );
    return option ? option.description : 'Selecione';
  };

  const handleSetNewValueFiltro = useCallback(() => {
    if (tags.length < 1 && condition !== 7 && condition !== 8) {
      if (!isFilterBlock) RemoveFilterEmptyByIndex(filter.index);
      return;
    }
    handleSetNewValue({
      index: filter.index,
      des_nome: filter.des_nome,
      nome_bd: filter.nome_bd,
      condicao: condition,
      des_valor:
        condition === naoPreenchido || condition === preenchido
          ? undefined
          : tags,
      cod_tipo_dados: filter.cod_tipo_dados,
      cod_tipo_info: filter.cod_tipo_info,
      cod_campo: filter.cod_campo,
      isBlock: isFilterBlock,
      expressao_validacao: filter.expressao_validacao,
      listagem_info: filter.listagem_info,
      tipo_expressao: filter.tipo_expressao,
    });
  }, [
    tags,
    condition,
    isFilterBlock,
    RemoveFilterEmptyByIndex,
    filter,
    handleSetNewValue,
    naoPreenchido,
    preenchido,
  ]);

  // Removido o useEffect que executava automaticamente ao digitar
  // Agora a busca só acontece quando o usuário clica em "Atualizar"

  const handleTags = (newTags: any) => {
    setTags(newTags);
  };

  const availableOptions = isExpression ? optionsExpression : options;

  return (
    <FilterContainer>
      {/* Header com título, dropdown e botão de remover */}
      <FilterHeader>
        <FilterTitleRow>
          <FilterTitle>{filter.des_nome}</FilterTitle>
          <DropdownContainer ref={dropdownRef}>
            <DropdownButton
              isOpen={dropdownOpen}
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              {getConditionText(condition)}
              {dropdownOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
            </DropdownButton>
            {dropdownOpen && (
              <DropdownList>
                {availableOptions.map((opt) => (
                  <DropdownItem
                    key={opt.cod_condicao}
                    isSelected={condition === opt.cod_condicao}
                    onClick={() => handleChangeCondition(opt.cod_condicao)}
                  >
                    {opt.description}
                  </DropdownItem>
                ))}
              </DropdownList>
            )}
          </DropdownContainer>
        </FilterTitleRow>
      </FilterHeader>

      {/* Linha dos Inputs de Valor */}
      {condition !== naoPreenchido && condition !== preenchido && (
        <FilterRow>
          <FieldContainer>
            <EnterLabel>
              Pressione <kbd>Enter</kbd> para <strong>Confirmar</strong>
            </EnterLabel>
            <InputTagSt style={{ width: '100%' }}>
              <Tags
                tags={tags}
                onChange={(e: any) => {
                  setValue('');
                  handleTags(e);
                }}
                inputProps={{
                  type: 'text',
                  // mask: Mask,
                }}
              />
            </InputTagSt>
          </FieldContainer>
        </FilterRow>
      )}

      {/* Botão de Atualizar */}
      <FullWidthButton>
        <CustomButtonNovo
          style={{
            backgroundColor:
              tags.length < 1 && condition !== 7 && condition !== 8
                ? '#dcdfe0'
                : '#0052CC',
          }}
          type="button"
          onClick={handleSetNewValueFiltro}
          disabled={tags.length < 1 && condition !== 7 && condition !== 8}
          label="Atualizar"
        />
      </FullWidthButton>
    </FilterContainer>
  );
};

export default TypeString;
